// GroupsList.jsx
import React, { useEffect, useState } from "react";
import backend from "../../../../../api";
import AppHeader from "../../../../../components/AppHeader";
import { useNavigate } from "react-router-dom";
import "./GroupsList.css";
import { useSelector } from "react-redux";

export default function GroupsList() {
  const nav = useNavigate();
  const { user } = useSelector(s => s.auth);
  const userId = user?._id;

  const [groups, setGroups] = useState([]);
  const [err, setErr] = useState("");

  const load = async () => {
    try {
      setErr("");
      const res = await backend.get(`/groups/mine`, { params: { userId } });
      setGroups(res?.data?.data || []);
    } catch (e) {
      setErr(e?.response?.data?.message || "Failed to load groups");
    }
  };

  useEffect(() => { load(); }, [userId]);

  return (
    <div className="gr-page">
      <AppHeader title="Groups" onBack={() => nav(-1)} right={
        <button className="btn-brand" onClick={() => nav("/groups/create")}>Create</button>
      }/>
      {err && <div className="gr-error">{err}</div>}
      <div className="gr-list">
        {groups.map(g => (
          <div key={g._id} className="gr-item" onClick={() => nav(`/groups/${g._id}/chat`)} role="button">
            <div className="gr-avatar">👥</div>
            <div className="gr-name">{g.name}</div>
            <div className="gr-meta">{g.members?.length || 0} members</div>
            <button className="gr-edit" onClick={(e)=>{e.stopPropagation(); nav(`/groups/${g._id}/edit`);}}>⋯</button>
          </div>
        ))}
        {groups.length === 0 && <div className="gr-empty">No groups yet</div>}
      </div>
    </div>
  );
}